








import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
import { share } from '../api';
@Component
export default class Rules extends Vue {
  data: any = '';
  showOnlineTip = true;

  async created() {
    const res: any = await getRule();
    this.data = res.data;
    share(this);
  }
  mounted() {
    setTimeout(() => {
      this.showOnlineTip = false;
    }, 5000);
  }
}
